import { schoolTable1, schoolTable2, schoolTable3, schoolTable4, schoolTable5, schoolTable6, schoolTable7, } from "../../assets/images/solution/solutionImages"
//Attend
export const attendHeaderData = [
  { text: '기능설명', value: 'intro', widthClass: 'wkLeftBorderNone mbFont' },
  { text: '13.56MHz', value: 'mhz', widthClass: 'w25 mbFont' },
  { text: '프로토콜', value: 'ptc', widthClass: 'w25 mbFont' },
  { text: '근태관리 솔루션 워키', value: 'workey', widthClass: 'wkBlueTableHeader mbFont' },
]

export const attendBodytData = [
  {
    intro: { text: '제품가격(월 사용료)', className: 'wkLeftBorderNone mbFont' },
    mhz: { text: '400,000원(9,900원)', className: 'wkTableBody' },
    ptc: { text: '1,200,000원(5,500원)', className: 'wkTableBody' },
    workey: { text: '220,000원(월 사용료 없음)', className: 'wkBlueTableBody' },
  },
  {
    intro: { text: '장비당 최대 사용자', className: 'wkLeftBorderNone mbFont' },
    mhz: { text: '300명', className: 'wkTableBody' },
    ptc: { text: '500명', className: 'wkTableBody' },
    workey: { text: '8,000명', className: 'wkBlueTableBody' },
  },
  {
    intro: { text: '개인스케줄 및 Report 기능', className: 'wkLeftBorderNone mbFont' },
    mhz: { text: 'X', className: 'wkTableBody' },
    ptc: { text: 'O', className: 'wkTableBody' },
    workey: { text: 'O', className: 'wkBlueTableBody' },
  },
  {
    intro: { text: '근태 보고 및 문자 발송 기능', className: 'wkLeftBorderNone mbFont' },
    mhz: { text: 'X', className: 'wkTableBody' },
    ptc: { text: '단문(SMS)만 가능', className: 'wkTableBody' },
    workey: { text: 'SMS, LMS, MMS 발송가능', className: 'wkBlueTableBody' },
  },
  {
    intro: { text: '온/오프라인 실행', className: 'wkLeftBorderNone mbFont' },
    mhz: { text: '서비스 상품에 따라 다름', className: 'wkTableBody' },
    ptc: { text: '장비에 따라 다름', className: 'wkTableBody' },
    workey: { text: '모두 가능', className: 'wkBlueTableBody' },
  },
  {
    intro: { text: '무료 업데이트', className: 'wkLeftBorderNone mbFont' },
    mhz: { text: 'X', className: 'wkTableBody' },
    ptc: { text: 'X', className: 'wkTableBody' },
    workey: { text: 'O', className: 'wkBlueTableBody' },
  },
  {
    intro: { text: '유지보수', className: 'wkLeftBorderNone mbFont' },
    mhz: { text: '무상 보증 1년', className: 'wkTableBody' },
    ptc: { text: '무상 보증 1년', className: 'wkTableBody' },
    workey: { text: '업계 유일 2년 보증 대체장비 발송', className: 'wkBlueTableBody' },
  }, 
]

//School
export const schoolServiceHeaderData = [
  { text: '구분', value: 'sort', widthClass: 'scLeftBorderNone mbFont' },
  { text: '월비용', value: 'cost', widthClass: 'w33 mbFont' },
  { text: '등록 원생 인원', value: 'ps', widthClass: 'scRightBorderNone mbFont' },
]

export const schoolServiceBodytData = [
  {
    sort: { text: '스탠다드', className: 'wkLeftBorderNone mbFont' },
    cost: { text: '9,900원', className: 'wkTableBody' },
    ps: { text: '1-50명', className: 'scRightBorderNone mbFont' },
  },
  {
    sort: { text: '프리미엄', className: 'wkLeftBorderNone mbFont' },
    cost: { text: '16,500원', className: 'wkTableBody' },
    ps: { text: '51명 이상', className: 'scRightBorderNone mbFont' },
  },
]

export const schoolOtherHeaderData = [
  { text: '사진', value: 'img', widthClass: 'scLeftBorderNone mbFont' },
  { text: '장비명', value: 'name', widthClass: 'w33 mbFont' },
  { text: '구매 방법', value: 'purch', widthClass: 'scRightBorderNone mbFont' },
]

export const schoolOtherBodytData = [
  {
    img: { text: (<><img src={schoolTable1} alt="img"/><img src={schoolTable2} alt="img"/></>), className: 'wkLeftBorderNone scImg' },
    name: { text: '출결인증용 태블릿', className: 'wkTableBody' },
    purch: { text: (<>별도 문의<br /><br />아이킵스 관리자 Web에서<br />필요 장비만<br />원클릭 구매 가능!</>), className: 'scRightBorderNone  mbFont', rowSpan: 4},
  },
  {
    img: { text: (<><img src={schoolTable3} alt="img"/><img src={schoolTable4} alt="img"/></>), className: 'wkLeftBorderNone scImg' },
    name: { text: '출결인증용 NFC 리더기', className: 'wkTableBody' },
    purch: { text: null },
  },
  {
    img: { text: (<><img src={schoolTable5} alt="img"/><img src={schoolTable6} alt="img"/></>), className: 'wkLeftBorderNone scImg' },
    name: { text: '출결인증용 NFC 태그', className: 'wkTableBody' },
    purch: { text: null },
  },
  {
    img: { text: (<><img src={schoolTable7} alt="img"/></>), className: 'wkLeftBorderNone scImg' },
    name: { text: (<>SMS, LMS, MMS<br />문자메세지</>), className: 'wkTableBody' },
    purch: { text: null },
  },
]

export const rfHeaderdData = [
  { text: '인터페이스', value: 'itf', widthClass: 'scLeftBorderNone' },
  { text: '주파수대역', value: 'fb', widthClass: 'w33' },
  { text: '동작범위', value: 'rg', widthClass: 'w33' },
  { text: '동작확인', value: 'chk', widthClass: 'w33' },
  { text: '태그 R/W 속도', value: 'spd', widthClass: 'w33' },
  { text: '개발환경', value: 'dem', widthClass: 'w33' },
  { text: '공급전압 및 전류', value: 'vt', widthClass: 'w33' },
  { text: '운영온도', value: 'tp', widthClass: 'w33' },
  { text: '사이즈', value: 'sz', widthClass: 'scRightBorderNone' },
]

export const rfHeaderData = [
  { text: '', value: 'title', widthClass: 'inquertRegHeader' },
  { text: '', value: 'content', widthClass: 'inquertRegHeader' },
]


export const rfBodytData = [
  {
    title: { text: '인터페이스', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: 'USB Full Speed(12Mbps, Plug&Play)', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '주파수대역', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '13.56Mhz', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '동작범위', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: (<>10mm-70mm 이내<br/>(태그 안테나 사이즈 및 성능에 따라 차이가 있음)</>), className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '동작확인', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '태그의 Auto Detection기능', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '태그 R/W 속도', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: (<>212Kbps, 424Kbps,<br/>단 태그도 424Kbps 속도를 지원해야함</>), className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '개발환경', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: (<>PC/SC 표준 API 사용,<br/>Microsoft CCID 표준드라이버 사용</>), className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '공급전압 및 전류', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '5V DC, 최대 200mA', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '운영온도', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '0℃-50℃', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '사이즈', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '65mm x 98mm x 12.8t, 73g', className: 'rfDetailTableBodyBorder' },
  },
]


export const tagHeaderData = [
  { text: '', value: 'title', widthClass: 'inquertRegHeader' },
  { text: '', value: 'content', widthClass: 'inquertRegHeader' },
]


export const tagBodytData = [
  {
    title: { text: '제품명', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '900Mhz 등록기', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '주파수', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '900Mhz', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '프로토콜', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: 'ISO 18000-6B,6C (EPC Gen2)', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '인터페이스', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: 'USB VCP통신 (Virtual COM Port)', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '동작범위', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '10cm 이내', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '동작확인', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '평상시 : 적색 / 태깅 시 : 녹색', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '공급전압 및 전류', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: 'DC 5V / USB타입으로 별도 전원이 들어가지 않습니다', className: 'rfDetailTableBodyBorder' },
  },
  {
    title: { text: '제품사이즈', className: 'rfDetailTableHeadBorder mbFont' },
    content: { text: '104mm x 68mm x 10mm', className: 'rfDetailTableBodyBorder' },
  },
]